import React from 'react'
import style from "./bpmn-tars.module.css";
import {
  calculateWidthBetweenElements,
  getXMLFromJSON,
  onXMLImport,
  animateNodes,
  addMissingSequenceFlows,
  getMissingKeys,
  getOrder,
  getJSONFromXML,
  processExternalTask,
} from "./helpers";
import TextArea from "antd/lib/input/TextArea";
import { Select, Tooltip } from "antd";
import TarsIcon from "../../../../../../assets/images/tarsIcon.png";
import BroomIcon from "../../../../../../assets/svg/broom.svg";
import StarIcon from "../../../../../../assets/svg/star.svg";
import Axios from "axios";
import { getBusinessObject } from "@uniphore/a8-bpmn-modeler/lib/util/ModelUtil.js";
import { useSelector, useDispatch } from "react-redux";
import { setBPMNTarsVisibility } from "../../../../../../stateManager/store/common/action";
import { useToast } from "../../../../../../helpers/commonFunction";
import { ResourceLock } from "../../../../../../helpers/RxServices";
import { ReactComponent as TarsLoadingIcon } from "../../../../../../assets/svg/tars-loading.svg";
import { APIURL } from "../../../../../../constant/common";
import { Switch } from "antd";
import { logger } from "../../../../../../constant/winston";
import { useState, useEffect } from "react";
import { useParams } from 'react-router';
import { AppState } from '../../../../../../stateManager/store';
import { Http } from '../../../../../../helpers/axois';

const { Option } = Select;

type SetState<T> = React.Dispatch<React.SetStateAction<T>>

type Props = {
  bpmnModeler: any;
  setXMLStack: SetState<BPMNXMLStack>;
};

export type BPMNTarsMessage = {
  role: "user" | "assistant";
  content: string;
};

export type BPMNXMLStack = {
  stackIdx: number
  xml: string[]
}

export function BPMNTars(props: Props) {
  const { ErrorToast } = useToast();
  const dispatch = useDispatch();
  const [isMounted, setIsMounted] = useState(false)
  const isVisible = useSelector(
    (state: any) => state.common.bpmnTarsVisibility
  ) && isMounted;
  const { bpmnModeler, setXMLStack } = props;
  const [width, setWidth] = useState("auto");
  const [prompt, setPrompt] = useState("");
  const [messages, setMessages] = useState<BPMNTarsMessage[]>([]);
  const userMessages = messages.filter((message) => message.role === "user");
  const [loading, setLoading] = useState(false);
  const params: { appId?: string } = useParams()
  const appId: any = params.appId;
  const currentBranch: any = useSelector((state: any) => {
    const selectedAppId = state.apps.selectedApp && state.apps.selectedApp.id
    return (state.apps.appBranch && state.apps.appBranch[selectedAppId]) || {}
  }, (left: any, right: any) => left.branchId === right.branchId)
  const versionId = useSelector((state: any) => {
    return appId && state.apps.appVersion[appId].versionId
  })
  const [init, setInit] = useState(true) // used to determine whether to push the initial xml to xmlStack

  // enabling this option will expand the user given prompt
  // only applicable for the first message in the conversation
  const [expandPrompt, setExpandPrompt] = useState(true)

  function calcAndSetWidth() {
    const palette = document.querySelector(".djs-palette.two-column");
    const panel = document.querySelector("#js-properties-panel");
    if (palette && panel) {
      const distance = calculateWidthBetweenElements(palette, panel);
      setWidth(distance + "px");
    }
  }

  const getActionIDs = (process: Record<string, any>): string[] => {
    let actionIds: string[] = [];
    Object.keys(process).forEach((key) => {
      const item = process[key];

      if (item?.externalTask === "action") {
        actionIds.push(`${key}`);
      }

      if (item?.type === "subProcess" && item?.process) {
        const nested = getActionIDs(item.process);
        actionIds = actionIds.concat(nested);
      }
    });

    return actionIds;
  }

 const getActionKey = (key: string, process: Record<string, any>): string => {
  const item = process[key];
  if (item) {
    return `${item.name}:${item.integrationName || ""}`;
  }

  for (const processKey of Object.keys(process)) {
    const subProcess = process[processKey];
    if (subProcess?.type === "subProcess" && subProcess?.process) {
      const result = getActionKey(key, subProcess.process);
      if (result) return result; 
    }
  }

  return "";
};

  async function onKeyDown(e: React.KeyboardEvent<HTMLTextAreaElement>) {
    if (e.key == "Enter" && prompt.trim().length && !e.shiftKey) {
      setLoading(true);
      try {
        // if this is a follow up question, we need to pass the JSON representation
        // of the current XML
        const updatedXML = await bpmnModeler.current.saveXML()
        const jsonFromXML = getJSONFromXML(updatedXML.xml)

        const botMessages = messages.filter(
          (message) => message.role === "assistant"
        );
        const promptPrefix = botMessages.length ? ("```json" + "\n" + JSON.stringify(jsonFromXML) + "\n```\n") : ""
        // const baseUrl = `https://${APIURL.split("/")[2]}`;
        const endpoint = `${APIURL}/apps/${appId}/tars/generate-workflow?versionId=${versionId}&branchId=${currentBranch.branchId}`;
        const { data } = await Axios.post(endpoint, {
          prompt: promptPrefix + prompt.trim(),
          messages,
          expand_prompt: expandPrompt,
        }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("studioToken")}`
          }
        }
      );
        logger.info("model json:", data)

        // preserve the connected forms and services
        const keyAndTopicMap: Record<string, string> = {}
        const er = bpmnModeler.current.get("elementRegistry")
        er.getAll().forEach((el: any) => {
          if (el.type === 'bpmn:UserTask') {
            const bo = getBusinessObject(el)
            const formKey: string = bo.get('camunda:formKey') && bo.get('camunda:formKey').split(":").slice(1).join(':')
            if (formKey) {
              keyAndTopicMap[el.id] = formKey
            }
          }
          if (el.type === 'bpmn:ServiceTask') {
            const bo = getBusinessObject(el)
            const topicParts: string[] = bo.get('camunda:topic') ? bo.get('camunda:topic').split(":") : []
            if (topicParts.length > 1) {
              keyAndTopicMap[el.id] = topicParts.slice(1).join(":")
            }
            if(topicParts.length && topicParts[0] === "aiAgentTask") {
              const aiAgentKey = bo.get("camunda:aiAgentKey")
              if(aiAgentKey) {
                keyAndTopicMap[el.id] = aiAgentKey.split(":").slice(1).join(":")
              }
            }
          }
        })

        // Cleaning up the JSON produced by the model
        const json = data.data
        processExternalTask(json)
        addMissingSequenceFlows(json);
        logger.info("cleaned model json:", json)

        // If this follow-up question, we need to only animated the changed parts.
        // For that, we need to calculate the diff
        const prevJson = botMessages.length
          ? JSON.parse(botMessages[botMessages.length - 1].content)
          : undefined;
        let diff =
          prevJson && json ? getMissingKeys(prevJson, json) : undefined;
        const order = getOrder(json);
        diff = order.filter((item) => diff?.includes(item));

        // The JSON generated by the model only contains tasks. Using the "bpmn-auto-layout"
        // module the bpmndi tags can be generated dynamically
        const xml = await getXMLFromJSON("tars", json, keyAndTopicMap);
        await bpmnModeler.current.importXML(xml);
        const svg: SVGElement | null = document.querySelector(
          '[data-element-id="tars_bpmngenerator"]'
        );
        svg!.classList.remove("bpmnSVG");

        const bpmnReplace = bpmnModeler.current.get("bpmnReplace");
        const elementRegistry = bpmnModeler.current.get("elementRegistry");
        const modeling = bpmnModeler.current.get("modeling")

        // The "bpmn-auto-layout" module do not support expanded subprocess.
        // Here, we are manually expanding it using the bpmn modeler API
        const subprocessIDs = Object.keys(json).filter(
          (key) => json[key].type === "subProcess"
        );
        const actionsIDs = getActionIDs(json);
        if(actionsIDs.length) {
          const a8Window: any = window;
          Http.get(`/apps/${appId}/actions?branchId=${currentBranch.branchId}&versionId=${versionId}`).subscribe((res: any) => {
            actionsIDs.forEach((key: string) => {
              const actionKey = getActionKey(key, json)
              const filteredParameters = Object.keys(res.find((item: any) => {
                const func = item.function;
                if (`${func.name}:${func.integration_name}` === actionKey) { return item.type }
              })?.function?.parameters?.properties || {});
              if (filteredParameters?.length) {
                a8Window[key] = filteredParameters;
              }
            })
          }, (err) => {
            logger.error("failed to get actions", err);
          })
        }
  
        subprocessIDs.forEach((id) => {
          const subProcess = elementRegistry.get(id);
          if (subProcess) {
            const outgoing = subProcess.outgoing[0];
            const incoming = subProcess.incoming[0];
            if (outgoing && incoming) {
              const end = outgoing.businessObject.targetRef;
              const start = incoming.businessObject.sourceRef;
              if (start && end) {
                const startEl = elementRegistry.get(start.id);
                const endEl = elementRegistry.get(end.id);
                const newSubprocess = bpmnReplace.replaceElement(subProcess, {
                  type: "bpmn:SubProcess",
                  isExpanded: true,
                });
                modeling.moveShape(newSubprocess, {
                  x: Math.abs(newSubprocess.x - startEl.x) + 100,
                  y: 0,
                });
                modeling.moveShape(endEl, {
                  x: Math.abs(newSubprocess.width - endEl.x) + 250,
                  y: 0,
                });
              }
            }
          }
        });
        if (diff?.length) {
          diff.forEach((key) => {
            const node = document.querySelector(`[data-element-id='${key}']`);
            const parent = node?.parentElement;
            if (parent) {
              parent.style.opacity = "0";
            }
          });
          animateNodes(svg!, diff[0], diff);
        } else {
          onXMLImport(svg!, json, () => setLoading(false));
        }

        // To help the users to easily navigate between generated bpmn diagrams, we
        // are keeping track of the history
        const xmlStackPayload: string[] = []
        if (init) {
          xmlStackPayload.push(updatedXML.xml)
        }
        xmlStackPayload.push(xml)
        setXMLStack((prev) => {
          return {
            stackIdx: init ? 1 : prev.stackIdx + 1,
            xml: [...prev.xml, ...xmlStackPayload],
          }
        });
        setInit(false)

        let userPrompt = prompt
        if (data.prompt) {
          userPrompt += "\n\n---\n\n" + data.prompt
        }
        const newContext: BPMNTarsMessage[] = [
          { role: "user", content: userPrompt },
          { role: "assistant", content: JSON.stringify(json) },
        ];
        setMessages((prev) => [...prev, ...newContext]);
        setPrompt("");
        const element = document.getElementById("tarsChatHistory")
        if (element) {
          element.scrollTop = element.scrollHeight
        }
      } catch (err) {
        logger.error("error: onKeyDown:", err)
        ErrorToast("Failed. Try modifying your prompt.");
      } finally {
        setLoading(false);
      }
    }
  }

  useEffect(() => {
    window.addEventListener("resize", calcAndSetWidth);
    dispatch(setBPMNTarsVisibility(false));
    setIsMounted(true)
    setTimeout(() => {
      calcAndSetWidth();
    }, 800);
    return () => {
      window.removeEventListener("resize", calcAndSetWidth);
    };
  }, []);

  useEffect(() => {
    const subscriber = ResourceLock.getMessage().subscribe(({ message }) => {
      if (message === "FORM_REFETCHED") {
        setTimeout(() => {
          calcAndSetWidth();
        }, 800);
      }
    });
    return () => subscriber.unsubscribe();
  }, []);

  useEffect(() => {
    calcAndSetWidth()
  }, [isVisible]);

  return (
    <div
      className={style.bpmnTars}
      style={{
        display: width === "auto" ? "none" : "flex",
        width,
        transform: isVisible ? "translateY(0)" : "translateY(100%)",
      }}
    >
      <div className="flex items-center justify-between">
        <div className="flex gap-2 items-center">
          <img src={TarsIcon} alt="tars" width="33" height="33" />
          <p className="uppercase text-black font-bold relative top-3">A8Gen</p>
        </div>
        <div className="flex gap-4 items-center">
          <Tooltip title='Enable to generate a detailed prompt from your first message in the conversation'>
            <Switch
              size="small"
              checked={expandPrompt}
              onChange={setExpandPrompt}
            />
          </Tooltip>
          <button className={style.button} onClick={() => setMessages([])}>
            <img src={BroomIcon} />
          </button>
        </div>
      </div>

      {loading ? (
        <div className={style.loadingState}>
          <div>
            <TarsLoadingIcon />
          </div>
        </div>
      ) : (
          <>
            {Boolean(userMessages.length) ? (
              <div id="tarsChatHistory" className={style.chatHistory}>
                {userMessages.map((msg, i) => {
                  return (
                    <div key={i} className={style.chatItem}>
                      {msg.content}
                    </div>
                  )
                })}
              </div>
            ) : (
                <EmptyState />
              )}
          </>
        )}

      <div className="relative">
        <TextArea
          disabled={loading}
          onKeyPress={onKeyDown}
          value={prompt}
          autoSize={{ minRows: 1, maxRows: 2 }}
          className={style.promptInput}
          placeholder="Ask A8Gen - Your AI Powered automated BPMN journey creation"
          onChange={(e: any) => {
            setPrompt(e.target.value);
          }}
        />
      </div>
    </div>
  );
}

function EmptyState() {
  return (
    <div className={style.emptyState}>
      <div>
        <img src={StarIcon} alt="star" />
        <p style={{ color: "#052F35" }}>Example</p>
      </div>

      <div className={style.emptyStatePrompt}>
        Create a BPMN workflow that enables leave approval, including request
        submission, manager review, and final decision
      </div>
    </div>
  );
}
